import { createStyles } from 'antd-style';

import { ThemeSpaces } from '../theme';

export const useQuoteResultPageStyles = createStyles(
  ({ token }, { content } = {}) => ({
    quoteResultPage: {
      [`.${content}`]: {
        [`@media (min-width: ${token.screenLGMin}px) and (max-width: ${token.screenLGMax}px)`]:
          {
            paddingLeft: ThemeSpaces.SPACE_NORM_20,
            paddingRight: ThemeSpaces.SPACE_NORM_20,
          },
        [`@media (min-width: ${token.screenXLMin}px) and (max-width: ${token.screenXLMax}px)`]:
          {
            paddingLeft: ThemeSpaces.SPACE_NORM_30,
            paddingRight: ThemeSpaces.SPACE_NORM_30,
          },
      },
    },
  })
);
